<ng-container *ngIf="initialized">

<!--    <p-tabMenu [model]="tabItems" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>-->
    <p-tabs [(value)]="tabIndex" (valueChange)="onActiveItemChange($event)">
        <p-tablist>
            @for(item of tabItems; track item) {
                <p-tab [value]="item.id" >{{ item.label }}</p-tab>
            }
        </p-tablist>
    </p-tabs>

    <ng-container *ngIf="activeItem.id == 'pm.Person'">
        <mvs-widget
                *ngIf="widgetPerson"
                [widgetData]="widgetPerson"
        ></mvs-widget>
    </ng-container>

    <ng-container *ngIf="activeItem.id == 'pm.PersonAddress'">
        <mvs-widget
                *ngIf="widgetPersonAddressList"
                [widgetData]="widgetPersonAddressList"
                [importObjectContext]="contextPerson"
        ></mvs-widget>

    </ng-container>

    <ng-container *ngIf="activeItem.id == 'pm.PersonContact'">
        <mvs-widget
                *ngIf="widgetPersonContactList"
                [widgetData]="widgetPersonContactList"
                [importObjectContext]="contextPerson"
        ></mvs-widget>

    </ng-container>

</ng-container>
